import React, { useState, useEffect } from 'react';

export const HISTORY_KEY = 'toast_history';
const MAX_ENTRIES = 200;

export function pushToHistory(notification) {
    if (!notification || !notification.text) return;
    try {
        const stored = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
        const entry = { type: notification.type, text: notification.text, time: new Date().toISOString() };
        const updated = [entry, ...stored].slice(0, MAX_ENTRIES);
        localStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
    } catch (_) {}
}

function typeLabel(type) {
    if (type === 'error') return 'text-danger';
    if (type === 'success') return 'text-success';
    return 'text-info';
}

function formatTime(iso) {
    return new Date(iso).toLocaleString('pt-BR');
}

function ToastHistoryModal() {
    const [entries, setEntries] = useState([]);
    const [copyLabel, setCopyLabel] = useState('Copiar');

    function load() {
        try {
            setEntries(JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'));
        } catch (_) { setEntries([]); }
    }

    useEffect(() => {
        const el = document.getElementById('modalToastHistory');
        if (!el) return;
        el.addEventListener('show.bs.modal', load);
        return () => el.removeEventListener('show.bs.modal', load);
    }, []);

    function handleCopy() {
        const text = entries
            .map(e => `[${formatTime(e.time)}] [${(e.type || 'info').toUpperCase()}] ${e.text}`)
            .join('\n');
        navigator.clipboard.writeText(text).then(() => {
            setCopyLabel('Copiado!');
            setTimeout(() => setCopyLabel('Copiar'), 2000);
        });
    }

    function handleClear() {
        localStorage.removeItem(HISTORY_KEY);
        setEntries([]);
    }

    return (
        <div className='modal fade' id='modalToastHistory' tabIndex='-1' role='dialog'>
            <div className='modal-dialog modal-dialog-centered modal-lg' role='document'>
                <div className='modal-content'>
                    <div className='modal-header'>
                        <p className='modal-title'>Histórico de Notificações</p>
                        <button type='button' className='btn-close' data-bs-dismiss='modal'></button>
                    </div>
                    <div className='modal-body p-0'>
                        <div className='d-flex gap-2 align-items-center px-3 py-2 border-bottom'>
                            <span className='text-muted small'>{entries.length} notificação(ões)</span>
                            <div className='ms-auto d-flex gap-2'>
                                <button className='btn btn-sm btn-outline-light' onClick={handleCopy} disabled={!entries.length}>
                                    {copyLabel}
                                </button>
                                <button className='btn btn-sm btn-outline-danger' onClick={handleClear} disabled={!entries.length}>
                                    Limpar
                                </button>
                            </div>
                        </div>
                        <div style={{ maxHeight: 460, overflowY: 'auto', fontFamily: 'monospace', fontSize: 13 }}>
                            {entries.length === 0 && (
                                <p className='text-muted text-center py-4 mb-0'>Nenhuma notificação registrada.</p>
                            )}
                            {entries.map((e, i) => (
                                <div key={i} className={`px-3 py-2 border-bottom ${typeLabel(e.type)}`}>
                                    <span className='text-muted me-2' style={{ fontSize: 11 }}>{formatTime(e.time)}</span>
                                    {e.text}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ToastHistoryModal;
